import request from "@/utils/request";

export function getProjectDetail(data) {
  return request({
    url: "/api?c=project&a=getProjectDetail",
    method: "post",
    data,
  });
}

export function getPlayTag(data) {
  return request({
    url: "/api?c=project&a=getPlayTag",
    method: "post",
    data,
  });
}

//设置埋点
export function  setAegis(params){
   return request({
     url: "/community/custom.php?module=front&mod=home&ac=click",
     method: "get",
     headers:{
      'Connection': 'keep-alive'
     },
     params,
   });
}